import { render, staticRenderFns } from "./ChannelListing.vue?vue&type=template&id=710aa81c&scoped=true&"
import script from "./ChannelListing.vue?vue&type=script&lang=js&"
export * from "./ChannelListing.vue?vue&type=script&lang=js&"
import style0 from "./ChannelListing.vue?vue&type=style&index=0&id=710aa81c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710aa81c",
  null
  
)

export default component.exports